import React from 'react';
import { Menu, Grid, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { SubwayMenuProps } from './types';
import { StyledMenuDotButton, StyledMenuItem } from './styles';
import { getSubwayMenuItemId } from './utils';
import { useMenuControl } from './hooks/useMenuControl';

export const SubwayMenu = ({
  options,
  disabled,
  ...props
}: SubwayMenuProps) => {
  const { isOpen, open, close, ref, anchor } =
    useMenuControl<HTMLButtonElement>({
      disabled,
    });
  const theme = useTheme();

  return (
    <Grid
      item
      display="flex"
      justifyContent="flex-end"
      alignItems="flex-end"
      data-testid="subway-menu"
      {...props}
      sx={{
        flexShrink: 0,
        pointerEvents: disabled ? 'none' : 'auto',
        ...props.sx,
      }}
    >
      <StyledMenuDotButton
        id="basic-button"
        size="small"
        aria-controls={isOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        onClick={open}
        disableRipple
        ref={ref}
        data-testid="subway-menu-dots"
      >
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          color={theme.palette.grey[5]}
        />
      </StyledMenuDotButton>
      <Menu
        id="basic-menu"
        anchorEl={anchor}
        open={isOpen}
        onClose={close}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {options.map((option, index) => (
          <StyledMenuItem
            key={index}
            onClick={() => {
              option.onClick?.();
              close();
            }}
            disabled={option.disabled}
            data-testid={getSubwayMenuItemId(option.label)}
            type={option.type}
          >
            {option.label}
          </StyledMenuItem>
        ))}
      </Menu>
    </Grid>
  );
};
